<template>
	<div id="app">
		<div class="layer" v-show="$store.state.layoutShowing"></div>
		<div class="layout" v-show="$store.state.layoutShowing"></div>

<!-- 		<keep-alive :include="['home', 'home_sever', 'bid', 'home_class', 'pages', 'serClass', 'ser_detail', 'home_undete', 'packages']"
		 v-if="isRouterAlive">
			<router-view :key="$route.fullPath" v-if="$route.meta.keepAlive">
			</router-view>
		</keep-alive>
		<keep-alive :include="['home', 'home_sever', 'bid', 'home_class', 'pages', 'serClass', 'ser_detail', 'home_undete', 'packages']"
		 v-if="isRouterAlive">
			<router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view>
		</keep-alive> -->

		<keep-alive :include="['home', 'home_sever', 'bid', 'home_class', 'pages', 'serClass', 'ser_detail', 'home_undete', 'packages','limit','brandDetail']" v-if="isRouterAlive">
			<router-view :key="$route.fullPath" ></router-view>
		</keep-alive>
<!-- 		<router-view></router-view> -->
	</div>
</template>

<script>
	export default {
		name: 'App',
		provide() {
			return {
				reload: this.reload
			}
		},
		data() {
			return {
				path: '',
				isRouterAlive: true,
				includeArr: ['home', 'home_sever', 'bid', 'home_class', 'pages', 'serClass', 'ser_detail', 'home_undete',
					'packages'
				]
			}
		},
		// 判断路由
		mounted() {

		},
		methods: {

		},
		watch: {


		}
	}
</script>

<style>
	@import 'assets/style/font.css';

	html,
	body,
	#app {
		height: 100%;
		font-family: PF;
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		background: #f2f2f2;
	}

	.vjs-poster {
		background-size: contain !important;
	}

	a {
		color: #c8c8c8;
		font-size: 0.75rem;
	}

	#app .van-nav-bar i {
		color: #000;
	}

	.img-inner-box {
		border-radius: 0.3rem !important;
		overflow: hidden;
	}

	.van-search {
		width: 100%;
	}

	.van-search .van-cell {
		padding: 0 0 !important;
	}

	.van-index-anchor {
		padding: 0 !important;
	}

	.van-field__control {
		font-size: 0.75rem !important;
	}

	.van-index-bar__sidebar span {
		margin-bottom: 0.2rem;
		font-size: 0.8rem;
	}

	.van-sidebar {
		width: 4.4rem;
	}

	.van-sidebar a {
		font-size: 0.75rem;
		border-bottom: 1px solid #fff;
		padding-right: 0;
		padding-left: 0;
	}

	.van-image__img {
		border-radius: 0.2rem !important;
	}

	/* //app样式 */

	.nav {
		color: #fff;
		border-bottom: 1px solid #FFFFFF;
		display: flex;
		justify-content: space-between;
		padding: 0 0.5rem;
		align-items: center;
		box-sizing: border-box;
		background: #f1452f;
		width: 100%;
		height: 2rem;
		position: fixed;
		top: 2rem;
		font-size: 0.9rem;
		z-index: 2001;
	}

	/* 手机端样式 */
	/* 		.nav {
		color: #fff;
		border-bottom: 1px solid #FFFFFF;
		display: flex;
		justify-content: space-between;
		padding: 0 0.5rem;
		align-items: center;
		box-sizing: border-box;
		background: #f1452f;
		width: 100%;
		height: 2rem;
		position: fixed;
		top: 2rem;
		font-size: 0.9rem;
		z-index: 2001;
		margin-top: -2rem;
	} */

	.layer {
		width: 100%;
		height: 2.1rem;
		position: fixed;
		z-index: 888;
		background: #F1452F;
	}

	.layout {
		height: 2rem;
		width: 100%;
		background: #F1452F;
	}

	.special_serch,
	.van-search {
		padding-top: 0 !important;
		padding-bottom: 0 !important;
	}

	.custom-indicator {
		width: 2rem;
		height: 1.2rem;
		line-height: 1.2rem;
		border-radius: 1rem 0 0 1rem;
		position: absolute;
		bottom: 1rem;
		font-size: 0.7rem;
		right: 0;
		color: #fff;
		background: rgba(0, 0, 0, 0.3);
	}

	.wholeDetail .van-radio__label {
		display: flex;
		align-items: center;
	}

	.home .van-uploader__input {
		position: absolute;
		top: -5px;
		left: -10px;
		width: 100%;
		height: 100%;
		overflow: hidden;
		cursor: pointer;
		opacity: 0;
	}

	.wholeDetail .van-field__control--custom {
		display: block;
	}

	.wholeDetail .van-checkbox__label--disabled {
		color: #323232;
	}

	.close-icon {
		color: #fff;
		position: absolute;
		z-index: 4000;
		font-size: 0.8rem;
		top: 2rem;
		left: 1rem;
	}

	[class*=van-hairline]::after {
		border-bottom: 0;
		border-top: none;
	}

	.van-list__finished-text {
		font-size: 0.75rem;
	}

	.close-icon {
		color: #fff;
		position: absolute;
		z-index: 4000;
		font-size: 0.8rem;
		top: 3.5rem;
		left: 1rem;
	}

	.vue-waterfall-easy-container .vue-waterfall-easy a.img-inner-box {
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0) !important;
	}

	.home .vue-waterfall-easy .over {
		margin: 0.3rem 0 0.5rem 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue